<template>
    <div class="container">
        <div class="field p-l-20">
            <Checkbox type="radio" name="need_all_month" v-model="model.need_all_month" data-value="si" label="Sí, todo el mes"></Checkbox>
        </div>
        <div class="field p-l-20">
            <Checkbox type="radio" name="need_all_month" v-model="model.need_all_month" data-value="no" label="Sólo algunas semanas"></Checkbox>
        </div>
        <div v-if="model.need_all_month !== null && model.need_all_month == 'no'" id="scroll-how-many-weeks">
            <p class="is-size-5-desktop is-size-6-mobile pinkytext">¿Cuántas semanas?</p>
            <p class="candidtext is-size-6 m-b-10">Si, por ejemplo, son semanas alternas, selecciona 2 semanas</p>
            <div class="field has-addons">
                <p class="control">
                    <a class="button is-large is-size-7-tablet is-size-5-desktop"
                       :class="{ 'is-link': model.month_weeks === 1 }"
                       @click.prevent="model.month_weeks = 1">
                        <span>1</span>
                    </a>
                </p>
                <p class="control">
                    <a class="button is-large is-size-7-tablet is-size-5-desktop"
                       :class="{ 'is-link': model.month_weeks === 2 }"
                       @click.prevent="model.month_weeks = 2">
                        <span>2</span>
                    </a>
                </p>
                <p class="control">
                    <a class="button is-large is-size-7-tablet is-size-5-desktop"
                       :class="{ 'is-link': model.month_weeks === 3 }"
                       @click.prevent="model.month_weeks = 3">
                        <span>3</span>
                    </a>
                </p>
                <p class="control">
                    <a class="button is-large is-size-7-tablet is-size-5-desktop"
                       :class="{ 'is-link': model.month_weeks === 4 }"
                       @click.prevent="model.month_weeks = 4">
                        <span>4</span>
                    </a>
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import stepMixin from '../mixins/step';
import Checkbox from './Checkbox';

export default {
  name: 'funnel-paso-4',
  components: {
    Checkbox
  },
  mixins: [
    stepMixin
  ],
  methods: {
    updateScroll: function (id) {
      const target = document.getElementById(id);

      window.scrollTo({
        top: target.getBoundingClientRect().top + target.offsetHeight
      });
    }
  }
}
</script>
